import { useEffect, useState, useCallback } from "react";
import { useTranslate } from "src/locales";
import { referenceService } from "src/api/references/referenceService";
import ByzAsynchronousSelectV2 from "src/components/core-components/ByzAsynchronousSelectV2";
import { HospitalFloorResponseDto } from "src/api/references/referenceServicesDtos";

interface FloorListProps {
  handleChange: (
    value: HospitalFloorResponseDto | HospitalFloorResponseDto[] | null
  ) => void;
  multiple?: boolean;
  value?: HospitalFloorResponseDto | HospitalFloorResponseDto[] | null;
  sx?: any;
  hbId?: number;
  offId?: number;
  disabled?: boolean;
  placeholder?: string;
}

export default function FloorList({
  handleChange,
  multiple = false,
  value,
  sx,
  hbId = -1,
  offId,
  disabled = false,
  placeholder,
}: FloorListProps) {
  const [selectedFloor, setSelectedFloor] = useState<
    HospitalFloorResponseDto | HospitalFloorResponseDto[] | null
  >(value ?? null);

  const { t } = useTranslate();

  useEffect(() => {
    setSelectedFloor(value ?? null);
  }, [value]);

  // Şube veya Bina değiştiğinde floor'u sıfırla
  useEffect(() => {
    setSelectedFloor(null);
    handleChange(null);
  }, [hbId, offId]);

  const fetchFloors = useCallback(async (): Promise<HospitalFloorResponseDto[]> => {
    return await referenceService.hospitalFloors.getAllHospitalFloorsByHbId({ hbId, offId });
  }, [hbId, offId]);

  return (
    <ByzAsynchronousSelectV2<HospitalFloorResponseDto>
      fetchOptions={fetchFloors}
      label={t("floor-select")}
      onChange={(value) => {
        setSelectedFloor(value);
        handleChange(value);
      }}
      value={selectedFloor}
      selectLabel="name"
      multiple={multiple}
      sx={sx}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}
